import * as React from 'react';
import { z } from "zod";
import { Container, Table, tableCellClasses, Button, Box, Grid } from '@mui/material';
import { jsPDF } from 'jspdf';
import { FormModal, RHFTextField } from "../components/form";
import 'jspdf-autotable'; // For auto-generating tables in PDF
import { fetchVehicles, fetchCustomers, fetchSalesCoordinatorNewInstallations } from "../services/ApiService";
import DataTable from '../components/DataTable';

const employeeSchema = z.object({
  deviceId: z.string().min(1, "Required"),
  date: z.string().min(1, "Required"),
  time: z.string().min(1, "Required"),
  haulier: z.string().min(1, "Required"),
  truck: z.string().min(1, "Required"),
  cost: z.string().min(1, "Required"),
  expiryDate: z.string().min(1, "Required"),
  remarks: z.string().min(1, "Required"),
});

const employeeDefaultValues = {
  deviceId: "",
  date: "",
  time: "",
  haulier: "",
  truck: "",
  cost: "",
  expiryDate: "",
  remarks: "",
};

export function Invoice() {
  // const devices = [
  //   {
  //     deviceId: "D001",
  //     date: "2024-12-22",
  //     time: "10:00 AM",
  //     haulier: "John Doe Logistics",
  //     truck: "Truck-101",
  //     cost: "$500",
  //     expiryDate: "2025-01-01",
  //     remarks: "No issues reported."
  //   },
  //   {
  //     deviceId: "D002",
  //     date: "2024-12-21",
  //     time: "11:30 AM",
  //     haulier: "Jane Smith Transport",
  //     truck: "Truck-102",
  //     cost: "$450",
  //     expiryDate: "2025-01-10",
  //     remarks: "Requires inspection."
  //   },
  //   {
  //     deviceId: "D003",
  //     date: "2024-12-20",
  //     time: "02:15 PM",
  //     haulier: "Alice Johnson Services",
  //     truck: "Truck-103",
  //     cost: "$600",
  //     expiryDate: "2025-02-01",
  //     remarks: "Scheduled for maintenance."
  //   },
  //   {
  //     deviceId: "D004",
  //     date: "2024-12-19",
  //     time: "04:00 PM",
  //     haulier: "Bob Brown Haulage",
  //     truck: "Truck-104",
  //     cost: "$550",
  //     expiryDate: "2025-01-20",
  //     remarks: "Operational."
  //   },
  //   {
  //     deviceId: "D005",
  //     date: "2024-12-18",
  //     time: "09:00 AM",
  //     haulier: "Charlie Davis Freight",
  //     truck: "Truck-105",
  //     cost: "$700",
  //     expiryDate: "2025-03-15",
  //     remarks: "High priority delivery."
  //   },
  //   {
  //     deviceId: "D006",
  //     date: "2024-12-17",
  //     time: "12:00 PM",
  //     haulier: "Daniel Evans Logistics",
  //     truck: "Truck-106",
  //     cost: "$650",
  //     expiryDate: "2025-02-28",
  //     remarks: "Pending approval."
  //   },
  //   {
  //     deviceId: "D007",
  //     date: "2024-12-16",
  //     time: "03:30 PM",
  //     haulier: "Ella Fisher Haulage",
  //     truck: "Truck-107",
  //     cost: "$400",
  //     expiryDate: "2025-01-05",
  //     remarks: "Inspection overdue."
  //   },
  //   {
  //     deviceId: "D008",
  //     date: "2024-12-15",
  //     time: "05:00 PM",
  //     haulier: "Frank Green Transport",
  //     truck: "Truck-108",
  //     cost: "$550",
  //     expiryDate: "2025-04-10",
  //     remarks: "Requires follow-up."
  //   },
  //   {
  //     deviceId: "D009",
  //     date: "2024-12-14",
  //     time: "08:00 AM",
  //     haulier: "Grace Harris Freight",
  //     truck: "Truck-109",
  //     cost: "$500",
  //     expiryDate: "2025-02-05",
  //     remarks: "No action needed."
  //   },
  //   {
  //     deviceId: "D010",
  //     date: "2024-12-13",
  //     time: "01:00 PM",
  //     haulier: "Hannah Irving Haulage",
  //     truck: "Truck-110",
  //     cost: "$600",
  //     expiryDate: "2025-03-01",
  //     remarks: "Pending dispatch."
  //   },
  //   {
  //     deviceId: "D011",
  //     date: "2024-12-12",
  //     time: "10:45 AM",
  //     haulier: "Isaac Jenkins Freight",
  //     truck: "Truck-111",
  //     cost: "$550",
  //     expiryDate: "2025-01-15",
  //     remarks: "Requires further documentation."
  //   },
  //   {
  //     deviceId: "D012",
  //     date: "2024-12-11",
  //     time: "07:15 PM",
  //     haulier: "Jack Keller Logistics",
  //     truck: "Truck-112",
  //     cost: "$700",
  //     expiryDate: "2025-05-30",
  //     remarks: "Scheduled for upgrade."
  //   },
  //   {
  //     deviceId: "D013",
  //     date: "2024-12-10",
  //     time: "02:45 PM",
  //     haulier: "Lily Martin Haulage",
  //     truck: "Truck-113",
  //     cost: "$650",
  //     expiryDate: "2025-03-25",
  //     remarks: "Awaiting approval."
  //   },
  //   {
  //     deviceId: "D014",
  //     date: "2024-12-09",
  //     time: "11:00 AM",
  //     haulier: "Mason Lewis Transport",
  //     truck: "Truck-114",
  //     cost: "$500",
  //     expiryDate: "2025-02-20",
  //     remarks: "Pending quality check."
  //   },
  //   {
  //     deviceId: "D015",
  //     date: "2024-12-08",
  //     time: "04:15 PM",
  //     haulier: "Nina Parker Logistics",
  //     truck: "Truck-115",
  //     cost: "$400",
  //     expiryDate: "2025-01-30",
  //     remarks: "Needs repair."
  //   }
  // ]
  const [haulierOptions, setHaulierOptions] = React.useState([]);
    const [truckOptions, setTruckOptions] = React.useState([]);
  
    const [snackbar, setSnackbar] = React.useState({ open: false, message: '', severity: 'success' }); // Snackbar state
    const showSnackbar = (message, severity) => {
      setSnackbar({ open: true, message, severity });
    };
  
    const handleSnackbarClose = () => {
      setSnackbar({ ...snackbar, open: false });
    };
  
    const fetchTruck = async () => {
      try {
        const response = await fetchVehicles();
        const haulierDict = response.data.reduce((acc, item) => {
          acc[item.id] = item.registration_number;
          return acc;
        }, {});
        setTruckOptions(haulierDict)
        showSnackbar('Hauliers fetched successfully', 'success');
      } catch (error) {
        const errorMessage =
          error.response?.statusText || error.message || 'Error fetching hauliers';
        showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
      }
    };
    const fetchHauliers = async () => {
      try {
        const response = await fetchCustomers();
        const haulierDict = response.data.reduce((acc, item) => {
          acc[item.id] = item.name;
          return acc;
        }, {});
        setHaulierOptions(haulierDict)
        showSnackbar('Hauliers fetched successfully', 'success');
      } catch (error) {
        const errorMessage =
          error.response?.statusText || error.message || 'Error fetching hauliers';
        showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
      }
    };
    React.useEffect(() => {
      fetchDeliveries();
      fetchHauliers()
      fetchTruck()
    }, []);
  const [employees, setEmployees] = React.useState([])
  const [modalOpen, setModalOpen] = React.useState(false);
  // Save employees to localStorage on update
  React.useEffect(() => {
    // localStorage.setItem('employees', JSON.stringify(employees));
  }, [employees]);

  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);
  // const handleSave = async (newEmployee) => {
  //   try {
  //     const response = await fetch('https://crm-backend.monit.tech/api/employees/', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify(newEmployee),
  //     });

  //     if (response.ok) {
  //       const savedEmployee = await response.json();
  //       setEmployees((prev) => [...prev, savedEmployee]);
  //     } else {
  //       console.error("Failed to save employee:", response.statusText);
  //     }
  //   } catch (error) {
  //     console.error("Error saving employee:", error);
  //   }
  // };

  const handleExport = () => {
    const doc = new jsPDF();
    // Title
    doc.setFontSize(18);
    doc.text('Employees Report', 14, 16);

    // Create table
    const tableData = employees.map(record => [
      record.deviceId,
      record.date,
      record.time,
      record.haulier,
      record.truck,
      record.cost,
      record.expiryDate,
      record.remarks,

    ]);

    // Table Columns
    const columns = [
      'Device ID', 'Date', 'Time', 'Haulier', 'Truck', 'Cost', 'Expiry Date',"Remarks"];

    // Auto-table to generate table in PDF
    doc.autoTable({
      head: [columns],
      body: tableData,
      startY: 30, // Adjust starting position for the table
    });

    doc.save('Device Report.pdf');
  };
  // React.useEffect(() => {
  //   const fetchEmployees = async () => {
  //     try {
  //       const response = await fetch('https://crm-backend.monit.tech/api/employees/');
  //       const data = await response.json();
  //       setEmployees(data);
  //     } catch (error) {
  //       console.error("Error fetching employees:", error);
  //     }
  //   };

  //   fetchEmployees();
  // }, []);

  // const handleSave = (newEmployee) => {
  //   // Calculate next employee ID
  //   const lastEmployeeId = employees.length
  //     ? parseInt(employees[employees.length - 1].employeeId.slice(1), 10)
  //     : 15; // Start from E015
  //   const nextEmployeeId = `E${String(lastEmployeeId + 1).padStart(3, '0')}`;

  //   // Add new employee with generated ID
  //   setEmployees((prev) => [...prev, { ...newEmployee, employeeId: nextEmployeeId }]);
  // };
  const fetchDeliveries = async () => {
    try {
      const response = await fetchSalesCoordinatorNewInstallations();
      console.log(response.data);

      setEmployees(response.data);
      showSnackbar('Hauliers fetched successfully', 'success');
    } catch (error) {
      const errorMessage =
        error.response?.statusText || error.message || 'Error fetching hauliers';
      showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
    }
  };
  const EmployeeModal = ({ open, handleClose }) => {
    return (
      <FormModal
        open={open}
        onClose={handleClose}
        title="Add New Device"
        schema={employeeSchema}
        defaultValues={employeeDefaultValues}
        onSubmit={async (data) => { handleClose(); }}
        submitLabel="Add Device"
        width={400}
      >
        {({ control }) => (
          <Grid container spacing={2.5}>
            <Grid item xs={12} md={6}>
              <RHFTextField control={control} name="deviceId" label="Device Id" required />
            </Grid>
            <Grid item xs={12} md={6}>
              <RHFTextField control={control} name="date" label="Date" required />
            </Grid>
            <Grid item xs={12} md={6}>
              <RHFTextField control={control} name="time" label="Time" required />
            </Grid>
            <Grid item xs={12} md={6}>
              <RHFTextField control={control} name="haulier" label="Haulier" required />
            </Grid>
            <Grid item xs={12} md={6}>
              <RHFTextField control={control} name="truck" label="Truck" required />
            </Grid>
            <Grid item xs={12} md={6}>
              <RHFTextField control={control} name="cost" label="Cost" required />
            </Grid>
            <Grid item xs={12} md={6}>
              <RHFTextField control={control} name="expiryDate" label="Expiry Date" required />
            </Grid>
            <Grid item xs={12} md={6}>
              <RHFTextField control={control} name="remarks" label="Remarks" required />
            </Grid>
          </Grid>
        )}
      </FormModal>
    );
  };

  function getBase64Image(imgPath) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = imgPath; // Ensure this path points to your public folder image
  
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        const dataUrl = canvas.toDataURL(); // This will give you the base64 string
        resolve(dataUrl); // Return the complete base64 string (including header)
      };
  
      img.onerror = reject;
    });
  }
  

  
  const handleExportInvoice = (record) => {
    const doc = new jsPDF();
  
    // Title
    doc.setFontSize(18);
    doc.text(`Invoice Report for Device ${record.deviceId}`, 14,35);
  
    // Add Logo Image to PDF
    getBase64Image('/logo2.png').then((base64) => {
      // Add the image at the top (e.g., position at x=14, y=20)
      doc.addImage(base64, 'PNG', 14, 2, 50, 20); // Adjust width and height as needed
      let yPosition = 50; // Starting Y position for data

       // Key-Value style
    const fieldNames = [
      'Device ID', 'Date', 'Time', 'Haulier', 'Truck', 'Cost', 'Expiry Date', 'Remarks'
    ];
    
    const fieldValues = [
      record.deviceId, record.date, record.time, record.haulier, record.truck, record.cost, record.expiryDate, record.remarks
    ];

    // Loop through the fields and print them as key-value pairs
    for (let i = 0; i < fieldNames.length; i++) {
      doc.text(`${fieldNames[i]}:`, 14, yPosition); // Field name (Key)
      doc.text(fieldValues[i], 70, yPosition); // Field value
      yPosition += 10; // Increase Y position for the next field
    }
      // Save the document
      doc.save('Device_Report.pdf');
    }).catch((err) => {
      console.error('Error loading image:', err);
    });
  };
  
    
  return (
    <Container maxWidth="xl" sx={{ m: 2 }}>
      <EmployeeModal
        open={modalOpen}
        handleClose={handleClose}
      />
      <DataTable
        title="Invoices List"
        columns={[
          { key: 'id', label: 'Device #' },
          { key: 'delivery_date', label: 'Date' },
          { key: 'time', label: 'Time', render: (row) => row.delivery_date },
          { key: 'haulier_id', label: 'Haulier', render: (row) => haulierOptions[row.haulier_id] },
          { key: 'truck_id', label: 'Truck', render: (row) => truckOptions[row.truck_id] },
          { key: 'cost', label: 'Cost', render: (row) => row.truck_id },
          { key: 'expiry_date', label: 'Expiry Date' },
          { key: 'remarks', label: 'Remarks' },
        ]}
        rows={employees}
        toolbarActions={<Button variant="contained" color="primary" style={{ marginLeft: "10px" }} onClick={handleExport}>Export to PDF</Button>}
        renderActions={(row) => (
          <Box display="flex" gap="10px">
            <Button size='small' style={{fontSize:"10px"}} variant="contained" color="success" onClick={() => handleExportInvoice(row)}>View Invoice</Button>
          </Box>
        )}
      />
    </Container>
  );
}

